import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Col, Dropdown, Grid, Layout, Menu, Row, Tooltip } from 'antd';
import { FC } from 'react';

import AdvertiserSelect from '../../../components/AdvertiserSelect';
import { useAuthentication } from '../../../components/AuthenticationProvider';

import HeaderButton from './Button';
import styles from './styles.module.less';
import TimezoneButton from './TimezoneButton';
import UserInfo from './UserInfo';

type HeaderProps = {
  open?: boolean;
  collapsed?: boolean;
  onToggle: () => void;
};

const Header: FC<HeaderProps> = ({
  open = false,
  onToggle,
  collapsed: collapsedProp = true,
}) => {
  const screens = Grid.useBreakpoint();

  const { logout } = useAuthentication();

  const collapsed = screens.md ? collapsedProp : !open;

  return (
    <Layout.Header className={styles.header}>
      <Row align="middle" gutter={16} justify="space-between" wrap={false}>
        <Col flex="auto">
          <Row align="middle" gutter={16} justify="start" wrap={false}>
            <Col hidden={screens.md}>
              <HeaderButton
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                onClick={onToggle}
                size="large"
              />
            </Col>
            <Col flex="auto">
              <AdvertiserSelect bordered={false} className={styles.select} />
            </Col>
          </Row>
        </Col>
        <Col>
          <Row justify="end" wrap={false}>
            <Col hidden={screens.xs}>
              <Row wrap={false}>
                <Col>
                  <Tooltip title="Platform Time">
                    <TimezoneButton />
                  </Tooltip>
                </Col>
              </Row>
            </Col>
            <Col>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item icon={<LogoutOutlined />} onClick={logout}>
                      Logout
                    </Menu.Item>
                  </Menu>
                }
                placement="bottomRight"
                trigger={['click']}
              >
                <HeaderButton>
                  <UserInfo />
                </HeaderButton>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout.Header>
  );
};

Header.displayName = 'Header';

export default Header;
